var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 1.33325C11.6827 1.33325 14.6673 4.31792 14.6673 7.99992C14.6673 11.6819 11.6827 14.6666 8.00065 14.6666C4.31865 14.6666 1.33398 11.6819 1.33398 7.99992C1.33398 4.31792 4.31865 1.33325 8.00065 1.33325ZM8.00065 2.66659C6.58616 2.66659 5.22961 3.22849 4.22941 4.22868C3.22922 5.22888 2.66732 6.58543 2.66732 7.99992C2.66732 9.41441 3.22922 10.771 4.22941 11.7712C5.22961 12.7713 6.58616 13.3333 8.00065 13.3333C9.41514 13.3333 10.7717 12.7713 11.7719 11.7712C12.7721 10.771 13.334 9.41441 13.334 7.99992C13.334 6.58543 12.7721 5.22888 11.7719 4.22868C10.7717 3.22849 9.41514 2.66659 8.00065 2.66659ZM8.00065 3.99992C8.16394 3.99994 8.32154 4.05989 8.44357 4.1684C8.56559 4.2769 8.64355 4.42642 8.66265 4.58859L8.66732 4.66659V7.72392L10.472 9.52859C10.5915 9.64856 10.661 9.80954 10.6661 9.97884C10.6713 10.1481 10.6118 10.3131 10.4998 10.4401C10.3878 10.5671 10.2316 10.6468 10.063 10.6629C9.89439 10.6789 9.72598 10.6302 9.59198 10.5266L9.52932 10.4713L7.52932 8.47125C7.4257 8.36755 7.35916 8.23259 7.33998 8.08725L7.33398 7.99992V4.66659C7.33398 4.48977 7.40422 4.32021 7.52925 4.19518C7.65427 4.07016 7.82384 3.99992 8.00065 3.99992Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.e0d99544dc6b7a7f9b6a49a559afaa58.svg";
export { ForwardRef as ReactComponent };